export const AD_SLOTS = {
    // 1. List/Grid Views (Tools Grid, Article List)
    // Best for: Tracking performance of ads in browsing feeds
    LIST_VIEW: '3417038153',

    // 2. Content Pages (Articles, Grid Info, Renewables, Oil & Gas)
    // Best for: High-context matching in long-form reading
    CONTENT_PAGE: '2985777402',

    // 3. Interactive Tools (Tariff, Bill Calc, Solar Sizing, etc.)
    // Best for: Capturing high-intent users engaged in specific tasks
    TOOL_INTERFACE: '2183847534',
};
